<template>
  <v-container>
    <vue-upload-component
      ref="upload"
      :maximum="100"
      :drop="true"
      input-id="file2"
      v-model="files"
      :multiple="true"
      :post-action="uploadURL"
      @input-file="inputFile"
      @input-filter="inputFilter"
    >
    </vue-upload-component>
    <v-layout row wrap>
      <v-flex xs12>
        <span class="headline">Datei hochladen</span>

      </v-flex>
      <v-flex xs12 class="subheading handpointer pa-2" @click="OnManuellUpload">
        Hier können Sie ihre Bilder hochladen.<br>
        Ziehen Sie dazu einfach per Drag & Drop Ihre Dateien hier rein oder
        klicken Sie hier:
      </v-flex>
    </v-layout>
    <v-layout class="justify-align-center">
      <v-flex xs12>
      </v-flex>
      <v-flex xs12>
        <center>
          <table class="" border="0" width="100%">
            <thead v-if="alreadyFile && alreadyFile.length > 0">
            <tr>
              <td><b>Vorschau</b></td>
              <td><b>Name</b></td>
              <td align="center"><b>Size</b></td>
              <td align="center"><b>Status</b></td>
              <td align="center"><b>Action</b></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(file, index) in alreadyFile" :key="file.id">
              <td>
                <img class="td-image-thumb" v-if="file.thumb" :src="file.thumb" style="max-height: 100px; max-width: 100px;"/>
                <span v-else>No Image</span>
              </td>
              <td>
                <div class="filename">
                  {{file.name}}
                </div>
              </td>
              <td align="center">{{toMB(file.size, 2)}}</td>
              <td align="center">
                <span style="color: green; font-weight: bold;">Bereits hochgeladen</span>
              </td>
              <td align="center">
                <v-btn color="red" dark @click.prevent="$refs.upload.remove(file)">Entfernen</v-btn>
              </td>
            </tr>
            </tbody>
          </table>
        </center>
      </v-flex>
    </v-layout>
    <v-layout class="justify-align-center">
      <v-flex xs12>
        <center>
          <table class="" border="0" width="100%">
            <thead v-if="files && files.length > 0">
            <tr>
              <th>Vorschau</th>
              <th>Name</th>
              <th>Width</th>
              <th>Height</th>
              <th>Size</th>
              <th>Speed</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!files.length">
              <td colspan="9">
                <v-layout @click="OnManuellUpload" class="pa-4 handpointer">
                  <v-flex class="text-xs-center">
                    <h4>Drop files anywhere to upload<br/>or</h4>
                    <label class="btn btn-lg btn-primary">Select Files</label>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
            <tr v-for="(file, index) in files" :key="file.id">
              <td>
                <img class="td-image-thumb" v-if="file.thumb" :src="file.thumb" style="max-height: 100px; max-width: 100px;"/>
                <span v-else>No Image</span>
              </td>
              <td>
                <div class="filename">
                  {{file.name}}
                </div>
                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                  <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                </div>
              </td>
              <td>{{file.width || 0}}</td>
              <td>{{file.height || 0}}</td>
              <td>{{toMB(file.size, 2)}}</td>
              <td>{{toMB(file.speed, 2)}}</td>

              <td v-if="file.error">{{file.error}}</td>
              <td v-else-if="file.success">success</td>
              <td v-else-if="file.active">active</td>
              <td v-else></td>
              <td align="right">
                <v-btn color="red" dark @click.prevent="$refs.upload.remove(file)">Entfernen</v-btn>
              </td>
            </tr>
            </tbody>
          </table>
        </center>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn color="green" dark v-if="(!this.$refs.upload || !$refs.upload.active) && files && files.length > 0" @click.prevent="$refs.upload.active = true">Jetzt hochladen</v-btn>
      </v-flex>
    </v-layout>
    <span v-if="decodedToken">{{decodedToken}}</span>
    <span v-if="uploadURL">{{uploadURL}}</span>
  </v-container>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import VueUploadComponent from 'vue-upload-component'
export default {
  name: 'FreeUpload',
  components: {VueUploadComponent},
  data () {
    return {
      decodedToken: null,
      files: [],
      alreadyFile: [],
      dialog: false,
      uploadURL: '',
      allDone: false
    }
  },
  methods: {
    toMB: function (bytes, decimals) {
      if (bytes === 0) return '0 Bytes'
      var k = 1024
      var dm = decimals <= 0 ? 0 : decimals || 2
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter (newFile, oldFile, prevent) {
      Vue.prototype.$api.log('inputFilter')
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
          this.$refs.dlgError.open({
            newName: '',
            messageTitle: 'Upload nicht möglich',
            type: 'Type',
            message: 'Diese Datei mit dem Namen "' + newFile.name + '" konnte nicht hinzugefügt werden. Aktuell werden folgende Formate unterstützt (jpeg,jpe,jpg,png)'
          })
          return prevent()
        }
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
        // Create a blob field
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
          // Thumbnails
          newFile.thumb = ''
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
            newFile.thumb = newFile.blob
          }
          // image size
          if (newFile && newFile.error === '' && newFile.type.substr(0, 6) === 'image/' && newFile.blob && (!oldFile || newFile.blob !== oldFile.blob)) {
            newFile.error = 'image parsing'
            let img = new Image()
            img.onload = () => {
              this.$refs.upload.update(newFile, {error: '', height: img.height, width: img.width})
            }
            img.onerror = (e) => {
              this.$refs.upload.update(newFile, {error: 'parsing image size'})
            }
            img.src = newFile.blob
          }
        }
      }
    },
    OnManuellUpload () {
      $('#file2').trigger('click')
    },
    checkAllDone () {
      let done = true
      for (var i in this.files) {
        var item = this.files[i]
        if (!item.success && !item.error) {
          done = false
        }
      }
      this.allDone = done
    },
    onGetAreadyFiles (res) {
      console.log('files', res.files)
      this.alreadyFile = res.files
    },
    inputFile (newFile, oldFile) {
      if (!this.dialog) {
        // this.initUploadDialog()
      }
      this.dialog = true

      Vue.prototype.$api.log('inputFile', newFile, oldFile)
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        Vue.prototype.$api.log('response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          console.log('status', newFile.xhr.status)
        }
      }
      if (newFile && oldFile) {
        // Update file

        // Start upload
        if (newFile.active !== oldFile.active) {
          console.log('Start upload', newFile.active, newFile)

          /*
          // min size
          if (newFile.size >= 0 && newFile.size < 100 * 1024) {
            newFile = this.$refs.upload.update(newFile, {error: 'size'})
          }

           */
        }

        // Upload progress
        if (newFile.progress !== oldFile.progress) {
          console.log('progress', newFile.progress, newFile)
        }

        // Upload error
        if (newFile.error !== oldFile.error) {
          console.log('error', newFile.error, newFile)
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          console.log('success', newFile.success, newFile)
          Vue.prototype.$eventHub.$emit('filespoolchanged')
        }
      }
      this.checkAllDone()
    }
  },
  mounted () {
    let token = Vue.prototype.$api.createUploadToken({
      klausurId: 1244,
      participantId: 12121212,
      questionId: 4444,
      column: 1,
      row: 1
    })
    let tokenBase64 = Vue.prototype.$api.hexEncode(token)
    let tokenDecoded = Vue.prototype.$api.hexDecode(this.$route.params.token)
    console.log('this.$router.params', this.$route.params, token, tokenBase64, tokenDecoded)
    this.decodedToken = Vue.prototype.$api.createTokenDataFromDecodedToken(tokenDecoded)
    this.uploadURL = Vue.prototype.$apiParticipant.getUploadUrl(this.$route.params.token)
    Vue.prototype.$apiParticipant.getUploadedFile(this.$route.params.token, this.onGetAreadyFiles)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FreeUpload.vue